export function fbqCompleteRegistration() {
  if (typeof globalThis.fbq !== 'undefined') {
    globalThis.fbq?.('track', 'CompleteRegistration', {})
  }
}
